module.exports = __webpack_public_path__ + "static/media/star-half.7a70dee4.png";